<template>
  <b-card no-body v-if="this.rawData">
    <b-card-body>
      <b-container fluid="xl">
        <div style="display: flex;">
          <div style="flex: 1.5;">
            <base-button size="sm" type="neutral" @click.native="refreshData()" style="float: right;">Refresh</base-button>
          </div>
        </div>
        <time-line type="one-side">
          <time-line-item v-for="(r, index) in this.rawData"
                          :badge-type="getBadgeType(r)"
                          :badge-icon="getBadgeIcon(r)">

            <div>
              {{ $formatDate(new Date(r.timestamp)) }}
            </div>
            <div>
              <h3>{{ $formatTime(new Date(r.timestamp)) }}</h3>
            </div>

            <h2 class=" mt-3 mb-0">{{ r.transferReason }}</h2>

            <base-button size="sm" type="primary" v-b-toggle="'data-'+r.timestamp" class="m-1">Data</base-button>
            <base-button size="sm" type="primary" v-if="r.transferReason === 'EVENTS'" v-b-toggle="'events-'+r.timestamp" class="m-1">Events</base-button>

            <b-collapse :id="'data-'+r.timestamp">
              <p/>
              Data
              <el-table class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        :data="getTableData(r, index)">

                <el-table-column label="type" prop="type" min-width="50px" />
                <el-table-column v-for="(column, columnIndex) in dataColumns" :label="column.label" :prop="column.prop" min-width="50px" />

              </el-table>
            </b-collapse>
            <b-collapse :id="'events-'+r.timestamp">
              <p/>
              Events
              <div v-for="(event, index) in r.events">
                <h3 style="display: inline-block">{{ $formatTime(new Date(Date.parse(r.timestamp))) }} : {{ event.eventType }}</h3>
              </div>
            </b-collapse>
          </time-line-item>
        </time-line>
      </b-container>
    </b-card-body>
  </b-card>
</template>

<script>
import crudApi from "../../crud/crud-api";
import { TimeLine, TimeLineItem } from '@/components';
import Badge from '@/components/Badge';
import { Table, TableColumn } from 'element-ui'

export default {
  components: {
    Badge,
    TimeLine,
    TimeLineItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  name: "entity-rawdata",
  props: {
    assetId: {
      type: String,
      required: true,
      description: "Asset ID"
    },
  },
  data: _ => ({
    rawData: undefined,
    dataColumns: [
      { label: "odo", prop: "odometer" },
      { label: "engine hours", prop: "engineHours" },
      { label: "total fuel", prop: "totalFuelUsed" },
      { label: "fuel idle", prop: "fuelUsedIdle"},
      { label: "fuel PTO", prop: "fuelUsedPTO" },
      { label: "driving time", prop: "drivingTime" },
      { label: "cruise time", prop: "cruiseTime" },
      { label: "pto time", prop: "ptoTime" },
      { label: "idle time", prop: "idleTime" },
      { label: "idle ts time", prop: "idleThresholdTime" },
      { label: "rpm ts time", prop: "rpmThresholdTime" },
      { label: "speed ts time", prop: "speedThresholdTime" },
      { label: "harsh accels", prop: "harshAccelerationThresholdTime" },
      { label: "harsh brakes", prop: "harshBrakeCount" }
    ]
  }),
  created() {
    this.getRawData()
  },
  watch: {
    '$store.state.filter.update': function () {
      this.refreshData()
    },
  },
  computed: {
    firstRawData() {
      if (this.rawData) {
        return this.rawData[len(this.rawData) - 1]
      } else {
        return undefined
      }
    },
  },
  methods: {
    refreshData() {
      this.getRawData()
    },
    getRawData() {
      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      crudApi.getAssetRawDatas(this.assetId, fromTime, untilTime).then(json => this.rawData = json.data ? json.data.slice().reverse() : json);
    },
    getBadgeType(rawData) {
      switch(rawData.transferReason) {
        case "EVENTS":
          return "info"
        case "TRIP_START":
          return "success"
        case "TRIP_STOP":
          return "danger"
        default:
          return "info"
      }
    },
    getBadgeIcon(rawData) {
      return "ni ni-bell-55"
    },
    getTableData(rawData, index) {
      let array = []
      let rawDataLength = this.rawData.length

      array.push(this.getRawDataDiff("Current data", rawData, undefined))

      if (index < rawDataLength-1) {
        let prevRawData = this.rawData[index+1]

        array.push(this.getRawDataDiff("Previous data", rawData, prevRawData))

        if (rawData.transferReason !== 'TRIP_START') {
          for (let tripStartIndex = index + 1; tripStartIndex <= rawDataLength - 1; tripStartIndex++) {
            if (this.rawData[tripStartIndex].transferReason === 'TRIP_START') {
              let prevRawData = this.rawData[tripStartIndex]

              array.push(this.getRawDataDiff("Trip start data", rawData, prevRawData))

              break
            }
          }
        }

        prevRawData = this.rawData[rawDataLength-1]

        array.push(this.getRawDataDiff("First data", rawData, prevRawData))
      }

      return array
    },
    getRawDataDiff(type, rawData, prevRawData) {
      let obj = {}

      obj['type'] = type

      for (let column of this.dataColumns) {
        if (prevRawData) {
          if (prevRawData && rawData[column.prop] && prevRawData[column.prop]) {
            obj[column.prop] = rawData[column.prop] - prevRawData[column.prop]

            if (!Number.isInteger(obj[column.prop])) {
              obj[column.prop] = obj[column.prop].toFixed(2)
            }

          } else {
            obj[column.prop] = "0"
          }
        } else {
          if (rawData[column.prop]) {
            obj[column.prop] = rawData[column.prop]

            if (!Number.isInteger(obj[column.prop])) {
              obj[column.prop] = obj[column.prop].toFixed(2)
            }
          } else {
            obj[column.prop] = "0"
          }
        }
      }

      return obj
    }
  }
}
</script>

<style scoped>

</style>
